import React,{useContext, useState} from 'react';
import useForm from "../../hooks/useForm";
import firebase from "../../firebase";
import {Error} from "../layout/Interface"; 
import UserContext from "../../context/user/UserContext";
import validationLogin from "../../validations/validationLogin";

const Login = ({history}) => {

    const {login} = useContext(UserContext);
    const [error, setError] = useState("");
    const {values, handleChange, reset} = useForm({
        email: "",
        password: ""
    });

    const {email, password} = values;

    async function signIn(){
        try{
            await firebase.signIn(email, password);
            login();
            history.push("/home");
            
        }
        catch(error){
            console.log(error.message);
            setError(validationLogin(error.message));
            setTimeout(() => {
                setError("");
            }, 2000);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        signIn();
    }

    return (
        <div className="bg-login">
            <div className="container">
                <div className="content">
                    <form className = "form" onSubmit = {handleSubmit}>
                        <div className="form-group">
                            {/* <label htmlFor="email">Email:</label> */}
                            <input 
                                type="email"
                                name = "email"
                                // autoComplete = "off"
                                placeholder = "Correo"
                                onChange = {handleChange}
                                required
                                />
                        </div>
                        <div className="form-group">
                            {/* <label htmlFor="password">Contraseña:</label> */}
                            <input 
                                type="password"
                                name = "password"
                                placeholder = "Contraseña"
                                onChange = {handleChange}
                                required
                                />
                        </div>
                        <div className="flex-center">
                            <input type="submit" value = "Iniciar Sesión" className = "btn-submit"/>
                        </div>
                        {error ? <Error>{error}</Error> :null}
                    </form>
                </div>
            </div>
        </div>
    );
}
 
export default Login;